import React, { useEffect, useContext } from "react";
import SkeletonProfile from "../layouts/SkeletonProfile";
import Repos from "../repos/Repos";
import { Link, useParams } from "react-router-dom";
import GithubContext from "../../context/github/githubContext";

const User = () => {
  const { login: loginParam } = useParams();
  const githubContext = useContext(GithubContext);
  const { getUser, loading, user, repos, getUserRepos } = githubContext;

  useEffect(() => {
    getUser(loginParam);
    getUserRepos(loginParam);
    document.title = `${loginParam} — GitHub Finder`;
    // eslint-disable-next-line
  }, [loginParam]);

  const {
    name,
    avatar_url,
    location,
    bio,
    blog,
    login,
    html_url,
    followers,
    following,
    public_repos,
    public_gists,
    hireable,
    company,
  } = user;

  if (loading) {
    return <SkeletonProfile />;
  }

  return (
    <div className="fade-in" style={{ paddingTop: "1.5rem" }}>
      <div className="profile-header">
        <Link to="/" className="btn">
          <i className="fas fa-arrow-left"></i> Back
        </Link>
        <span className={`hireable-badge ${hireable ? "hireable-yes" : "hireable-no"}`}>
          {hireable ? (
            <><i className="fas fa-check" /> Hireable</>
          ) : (
            <><i className="fas fa-times" /> Not Hireable</>
          )}
        </span>
      </div>

      <div className="profile-card">
        <div className="profile-grid">
          <div className="profile-avatar">
            <img src={avatar_url} alt={name} />
            <h1>{name}</h1>
            {location && (
              <p className="location">
                <i className="fas fa-map-marker-alt"></i> {location}
              </p>
            )}
          </div>
          <div className="profile-details">
            {bio && (
              <>
                <h3>Bio</h3>
                <p>{bio}</p>
              </>
            )}
            <a href={html_url} target="_blank" rel="noreferrer" className="btn btn-primary my-1">
              Visit GitHub Profile
            </a>
            <ul className="profile-meta">
              {login && (
                <li>
                  <strong>Username</strong> {login}
                </li>
              )}
              {company && (
                <li>
                  <strong>Company</strong> {company}
                </li>
              )}
              {blog && (
                <li>
                  <strong>Website</strong>{" "}
                  <a href={blog.startsWith("http") ? blog : `https://${blog}`} target="_blank" rel="noreferrer">
                    {blog}
                  </a>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>

      <div className="stats-row">
        <div className="stat-item">
          <div className="stat-value">{followers}</div>
          <div className="stat-label">Followers</div>
        </div>
        <div className="stat-item">
          <div className="stat-value">{following}</div>
          <div className="stat-label">Following</div>
        </div>
        <div className="stat-item">
          <div className="stat-value">{public_repos}</div>
          <div className="stat-label">Repos</div>
        </div>
        <div className="stat-item">
          <div className="stat-value">{public_gists}</div>
          <div className="stat-label">Gists</div>
        </div>
      </div>

      <Repos repos={repos} />
    </div>
  );
};

export default User;
